import NewCancelPage from "@/main/components/features/new_cancel/NewCancelPage"

const NewCancel = () => {
	return <NewCancelPage />
}

export default NewCancel
